import React, { useState } from 'react';

import { Container } from './styles';

const Item = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

export default Item;
